var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alarm)?_c('span',{staticClass:"alarmLevelIcon"},[_c('b-button',{attrs:{"variant":_vm.color}},[_vm._v(" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }